import { BaseService } from '../../infra/base.service'
import type { Comission } from './comission'
import type { ComissionsRepository } from './comissions.repository'

export class ComissionsService extends BaseService<Comission> {
    constructor(private rep: ComissionsRepository) {
        super(rep)
    }
}
